import { render, staticRenderFns } from "./OverwatchLayout.vue?vue&type=template&id=ba82ee84"
import script from "./OverwatchLayout.vue?vue&type=script&lang=ts"
export * from "./OverwatchLayout.vue?vue&type=script&lang=ts"
import style0 from "./OverwatchLayout.vue?vue&type=style&index=0&id=ba82ee84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports